import Swup from 'swup';

export const initSwup = (App) => {
    const swup = new Swup();

    swup.on('contentReplaced', () => {
        App.pageLoad();
    });

    // swup.on('samePage', e => {
    //     console.log('same');
    //     console.log(e.target);
    // })

    // swup.on('samePageWithHash', e => {
    //     console.log('samePWH');
    //     console.log(e.target);
    // })

    // swup.on('clickLink', e => {
    //     console.log('click link');
    //     console.log(e.target);
    //     console.log(e.target.target);
    // })

    return swup;
}